import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useStateRef from "react-usestateref";
// import './ProductPopup.css';
import EventEmitter from 'src/utils/EventEmitter';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { CloseSnackbarAction } from 'src/components/CloseSnackbarAction';
import CloseIcon from '@mui/icons-material/Close';
import { CheckExpiredToken } from 'src/components/CheckeExpiredToken';
import { LoadingView } from 'src/components/LoadingView';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
// import moment from 'moment/moment';

const PrescriberProductPopupView = (props) => {
  /* eslint-disable */
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading, loadingRef] = useStateRef(true);
  const [orderId, setOrderId, orderIdRef] = useStateRef(null);
  const [discountList, setDiscountList, discountListRef] = useStateRef([]);
  const [priceDetails, setPriceDetails, priceDetailsRef] = useStateRef({
    items: 0,
    total: 0,
    total_item: 0,
    tax: 0
  });

  const [orderItem, setOrderItem, orderItemRef] = useStateRef([]);
  const [prescriberName, setPresriberName, prescriberNameRef] = useStateRef('')
  const [tgaApprovalNumber, setTgaApprovalNumber, tgaApprovalNumberRef] = useStateRef([]);

  let totalUnits = 0;

  const headerData = [
    { id: "Product", name: "Product", width_table: 48 },
    // { id: "ExpireDate", name: "Expiry Date", width_table: 19 },
    { id: "Units", name: "Units", width_table: 19 },
    { id: "Price", name: "Price", width_table: 33 },
  ]
  /* eslint-enable */

  /* eslint-disable react-hooks/exhaustive-deps*/
  useEffect(() => {
    if (!initialized) {
      setLoading(true);
      setInitialized(true);
      getData();
    }

    if (props) {
      setPresriberName(props.customData.prescriber);
      setTgaApprovalNumber(props.customData.tga_approval_number)
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps*/

  const getData = async () => {
    const orderId = props.customData.orderId;

    try {
      let token = localStorage.user_token ? JSON.parse(localStorage.user_token) : '';

      await axios.get(`/csapi/orders/${orderId}?ProductFields=none`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      })
        .then(async response => {
          if (response.data) {
            if (response.data.Data) {
              var response_data = response.data.Data;

              if (response_data.Id) {

                var order_id = response.data.Data.Id;
                order_id = order_id.split('ORDER').join('').split('CART').join('');
                setOrderId(order_id);

                var product_list = response_data.OrderLines;

                var items_price = 0;
                var total_item = 0;
                var discount_list = [];

                const promises = product_list.map(async (value, index) => {
                  if (value.ProductId) {
                    if (value.Price.Price) {
                      items_price += value.Price.Price;
                    }
                    total_item++;
                  }

                  if (value.OrderLineType === "Discount" || value.OrderLineType === "ProductDiscount") {
                    if (value.Price) {
                      if (value.Price.PriceWithoutVat) {
                        var isSameDiscountName = false;
                        /* eslint-disable array-callback-return */
                        discount_list.map((discount_value, discount_index) => {
                          if (discount_value.name === value.ProductName) {
                            var new_price = discount_value.price_int + value.Price.PriceWithoutVat;
                            discount_list[discount_index].price_int = new_price;
                            discount_list[discount_index].price = isNaN(new_price) ? "$0.00" : "$" + formatNumber(new_price.toFixed(2));

                            isSameDiscountName = true;
                          }
                        })
                        /* eslint-enable array-callback-return */

                        if (!isSameDiscountName) {
                          discount_list.push({
                            name: value.ProductName,
                            price: value.Price ? value.Price.PriceWithoutVatFormatted : "$ 0.0",
                            price_int: value.Price ? value.Price.PriceWithoutVat : 0
                          })
                        }
                      }
                    }
                  }
                })

                await Promise.all(promises);

                setOrderItem(product_list);
                setDiscountList(discount_list);
                setPriceDetails({
                  items: items_price,
                  total: response.data.Data.Price ? response.data.Data.Price.PriceFormatted ?? "$0.00" : "$0.00",
                  tax: response.data.Data.Price ? response.data.Data.Price.VatFormatted ?? "$0.00" : "$0.00",
                  shipping: response.data.Data.ShippingFee ? response.data.Data.ShippingFee.PriceWithoutVatFormatted ?? "$0.00" : "$0.00",
                  total_item: total_item
                })
              }
            }
          }
        })

    } catch (e) {
      var error_message = e.response ? e.response.data ? e.response.data.Message ? e.response.data.Message : e.response.data : e.response.statusText : e.message;

      var is_token_expired = CheckExpiredToken(error_message);

      if (!is_token_expired) {
        enqueueSnackbar(error_message, { variant: 'error', autoHideDuration: 2000, preventDuplicate: true, action: CloseSnackbarAction });

        navigate('/orders');
        EventEmitter.emit("show_custom_popup", { value: false });
      }
    }
    setLoading(false);
  }

  const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const onClosePopup = () => {
    EventEmitter.emit("show_custom_popup", { value: false });
    if (window.location.pathname === "/" || window.location.pathname === "/dashboard") {
      EventEmitter.emit("update_cart_data", { value: true });
    }
  }

  const getListCartHeader = () => {
    var list = [];

    /* eslint-disable array-callback-return */
    headerData.map((value, index) => {
      list.push(
        <div key={index} className="child" style={{ "--width": value.width_table + "%" }} >
          <div className="text">{value.name}</div>
        </div>
      )
    })
    /* eslint-enable array-callback-return */

    return (<div className="orders-view-cart-header" style={{ minWidth: "100%" }}>{list}</div>)
  }

  const getListCartBody = () => {
    var list = [];

    if (orderItemRef.current === 0) {
      list.push(<div className="list no-data">No data available</div>)
    } else {
      /* eslint-disable array-callback-return */
      orderItemRef.current.map((value, index) => {
        if (value.ProductId) {

          const quantity = value.Quantity;
          totalUnits += quantity;

          // let expiryDate = '';
          // if (value.ProductFields) {
          //   if (value.ProductFields.ExpiryDate) {
          //     if (value.ProductFields.ExpiryDate.Value) {
          //       expiryDate = moment(value.ProductFields.ExpiryDate.Value).format('DD-MM-YYYY');
          //     }
          //   }
          // }

          var approval_number = "";
          var prescriber_name = "";
          var tga_document_exist = false;

          if (value.OrderLineFields) {
            if (value.OrderLineFields.TGAApprovalNumber) {
              if (value.OrderLineFields.TGAApprovalNumber.Value) {
                approval_number = value.OrderLineFields.TGAApprovalNumber.Value;
              }
            }

            if
              (value.OrderLineFields.DoctorsName) {
              if (value.OrderLineFields.DoctorsName.Value) {
                prescriber_name = value.OrderLineFields.DoctorsName.Value;
              }
            }

            if (value.OrderLineFields.TGAApprovalDocument) {
              if (value.OrderLineFields.TGAApprovalDocument.Value) {
                tga_document_exist = true;
              }
            }
          }
          if (tgaApprovalNumberRef.current.includes(approval_number)) {
            list.push(
              <>
                <div key={index}>
                  <div key={index} className="list" style={{ marginBottom: orderItemRef.current.length - 1 !== index ? "16px" : "" }}>
                    <div className="child orders-product-name-style" style={{ "--width": headerData[0].width_table + "%" }}>
                      <div className="cart-product-image-wrapper">
                        <img className="cart-image-wrapper-background" src="/static/images/meds/product_background_mobile.svg" alt="background" />
                        <img className="cart_product-image" src={value.ProductImage} alt={value.ProductName} />
                      </div>
                      <div className="cart-product-title">
                        <div className="text">{value.ProductName}</div>
                      </div>
                    </div>
                    <div className="child" style={{ "--width": headerData[1].width_table + "%" }}>
                      <div className="text">{quantity}</div>
                    </div>
                    <div className="child" style={{ "--width": headerData[2].width_table + "%" }}>
                      <div className="text">{value.Price.PriceWithoutVatFormatted} AUD</div>
                    </div>
                  </div>
                </div>
              </>
            )
          }
        }

      })
      /* eslint-enable array-callback-return */
    }

    return (<div className="orders-view-cart-body">{list}</div>)
  }

  // const onSubmit = () => {
  //   EventEmitter.emit("show_custom_popup", { value: false });

  //   navigate("/checkout");
  // }

  const getDiscountList = () => {
    const list = [];
    /* eslint-disable array-callback-return */
    discountListRef.current.map((value, index) => {
      list.push(
        <div key={index} className="order_summary-detail-2-wrapper-detail-intotal-list">
          <div className="order_summary-detail-2-text">{value.name}</div>
          <div className="order_summary-detail-2-price">{value.price}</div>
        </div>
      )
    })
    /* eslint-enable array-callback-return */

    return <>{list}</>
  }

  return (
    <div className="custom-popup-container-wrapper" style={{ height: "100%" }}>
      <div>
        <div className="custom-popup-container-wrapper-header">
          <div>{prescriberNameRef.current}</div>
          <div className="hide-mobile"><CloseIcon className="close-popup-icon" onClick={() => onClosePopup()} /></div>
        </div>
        {loadingRef.current ?
          <LoadingView /> :
          <div className="custom-popup-container-wrapper-body">
            <div style={{ paddingBottom: "20px" }}>Prescribed products with Order ID: {orderIdRef.current}</div>
            {orderItemRef.current.length > 0 ?
              <>
                <div>
                  {getListCartHeader()}
                  {getListCartBody()}
                </div>

                {discountListRef.current.length > 0 ?
                  getDiscountList() : ""}

                {priceDetailsRef.current.shipping !== "$0.00" && priceDetailsRef.current.shipping !== 0 ?
                  <div className="product-view-total" style={{ marginBottom: "0px" }}>
                    <div className="product-view-total-text" style={{ fontWeight: "400" }}>Shipping</div>
                    <div className="product-view-total-text-units"></div>
                    <div className="product-view-total-text-price" style={{ fontWeight: "400" }}>{priceDetailsRef.current.shipping}</div>
                  </div>
                  : ""}
              </>
              : <div style={{ textAlign: "center" }}>Your cart is empty.</div>
            }
          </div>
        }
      </div>
      <div className="custom-popup-container-wrapper-bottom-orders">
        <span onClick={() => window.open(process.env.REACT_APP_CHATBOT)} className="popup-support-link hide-mobile-order" style={{ marginTop: "0px", cursor: "pointer" }}><HelpOutlineIcon style={{ marginRight: "5px", fontSize: "16px" }} />Support</span>
        <button className={`custom-popup-button-green ${orderItemRef.current.length === 0 ? "disabled" : ""}`} onClick={() => onClosePopup()}>Submit</button>
        <span onClick={() => window.open(process.env.REACT_APP_CHATBOT)} className="popup-support-link hide-desktop" style={{ cursor: "pointer", marginTop: "5px", justifyContent: 'center' }}><HelpOutlineIcon style={{ marginRight: "5px", fontSize: "16px" }} />Support</span>
      </div>
    </div >
  );
}

export default PrescriberProductPopupView;